/**
 * The event names and the payload shapes live together so they cannot drift apart, and `as const`
 * gives a literal union, so `switch (envelope.type)` narrows and a mistyped name is a compile
 * error rather than a handler that silently never runs.
 */
export const BulkDownloadEvents = {
  started: 'bulk-download.started',
  ready: 'bulk-download.ready',
  failed: 'bulk-download.failed'
} as const;

export type BulkDownloadEventType = (typeof BulkDownloadEvents)[keyof typeof BulkDownloadEvents];

export interface BulkDownloadStartedPayload {
  jobId: string;
  fileCount: number;
}

export interface BulkDownloadReadyPayload {
  jobId: string;
  downloadUrl: string;
}

/** No failure detail by design — the server keeps the reason in its log, not on the wire. */
export interface BulkDownloadFailedPayload {
  jobId: string;
}
